// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charts-widget-notes h3 {
  margin-bottom: 20px;
  color: #1e293b;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
}
.charts-widget-notes h3::after {
  content: "";
  height: 3px;
  flex: 1 1;
  background: linear-gradient(90deg, #4f46e5, transparent);
  border-radius: 2px;
  margin-left: 12px;
}
.charts-widget-notes .no-notes {
  font-style: italic;
  color: #94a3b8;
  text-align: center;
  padding: 40px 20px;
  background: rgba(248, 250, 252, 0.5);
  border-radius: 12px;
  border: 2px dashed #e2e8f0;
  font-size: 15px;
}
.charts-widget-notes .notes-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 380px;
  overflow-y: auto;
  padding-right: 8px;
}
.charts-widget-notes .notes-grid::-webkit-scrollbar {
  width: 6px;
}
.charts-widget-notes .notes-grid::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}
.charts-widget-notes .notes-grid::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  border-radius: 10px;
}
.charts-widget-notes .notes-grid::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #3730a3, #5b21b6);
}
.charts-widget-notes .note-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(226, 232, 240, 0.6);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.charts-widget-notes .note-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.charts-widget-notes .note-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
  border-color: rgba(79, 70, 229, 0.2);
}
.charts-widget-notes .note-card:hover::before {
  opacity: 1;
}
.charts-widget-notes .note-card .note-header {
  margin-bottom: 12px;
}
.charts-widget-notes .note-card .note-header h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  line-height: 1.3;
}
.charts-widget-notes .note-card .note-body {
  font-size: 14px;
  color: #475569;
  margin-bottom: 16px;
  line-height: 1.5;
}
.charts-widget-notes .note-card .note-body p {
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.charts-widget-notes .note-card .note-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #64748b;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
}
.charts-widget-notes .note-card .note-footer span {
  background: rgba(248, 250, 252, 0.8);
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (max-width: 768px) {
  .charts-widget-notes {
    padding: 16px;
    border-radius: 12px;
  }
  .charts-widget-notes h3 {
    font-size: 1.2rem;
    margin-bottom: 16px;
  }
  .charts-widget-notes .notes-grid {
    gap: 12px;
    max-height: 300px;
  }
  .charts-widget-notes .note-card {
    padding: 16px;
  }
  .charts-widget-notes .note-card .note-header h4 {
    font-size: 1rem;
  }
  .charts-widget-notes .note-card .note-body {
    font-size: 13px;
    margin-bottom: 12px;
  }
  .charts-widget-notes .note-card .note-footer {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
  .charts-widget-notes .note-card .note-footer span {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ChartsWidget/ChartsWidget.scss"],"names":[],"mappings":"AACE;EAEE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;EACE,WAAA;EACA,WAAA;EACA,SAAA;EACA,wDAAA;EACA,kBAAA;EACA,iBAAA;AADN;AAKE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AAOI;EACE,UAAA;AALN;AAQI;EACE,mBAAA;EACA,mBAAA;AANN;AASI;EACE,qDAAA;EACA,mBAAA;AAPN;AAUI;EACE,qDAAA;AARN;AAYE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,0CAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AAVJ;AAYI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qDAAA;EACA,UAAA;EACA,6BAAA;AAVN;AAaI;EACE,2BAAA;EACA,0CAAA;EACA,oCAAA;AAXN;AAaM;EACE,UAAA;AAXR;AAeI;EACE,mBAAA;AAbN;AAeM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAbR;AAiBI;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAfN;AAiBM;EACE,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAfR;AAmBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,6BAAA;AAjBN;AAmBM;EACE,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAjBR;;AAwBA;EACE;IACE,aAAA;IACA,mBAAA;EArBF;EAuBE;IACE,iBAAA;IACA,mBAAA;EArBJ;EAwBE;IACE,SAAA;IACA,iBAAA;EAtBJ;EAyBE;IACE,aAAA;EAvBJ;EAyBI;IACE,eAAA;EAvBN;EA0BI;IACE,eAAA;IACA,mBAAA;EAxBN;EA2BI;IACE,sBAAA;IACA,QAAA;IACA,uBAAA;EAzBN;EA2BM;IACE,eAAA;EAzBR;AACF","sourcesContent":[".charts-widget-notes {\r\n  h3 {\r\n    // font-size: 1.4rem;\r\n    margin-bottom: 20px;\r\n    color: #1e293b;\r\n    font-weight: 700;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    \r\n    &::after {\r\n      content: '';\r\n      height: 3px;\r\n      flex: 1;\r\n      background: linear-gradient(90deg, #4f46e5, transparent);\r\n      border-radius: 2px;\r\n      margin-left: 12px;\r\n    }\r\n  }\r\n\r\n  .no-notes {\r\n    font-style: italic;\r\n    color: #94a3b8;\r\n    text-align: center;\r\n    padding: 40px 20px;\r\n    background: rgba(248, 250, 252, 0.5);\r\n    border-radius: 12px;\r\n    border: 2px dashed #e2e8f0;\r\n    font-size: 15px;\r\n  }\r\n\r\n  .notes-grid {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    max-height: 380px;\r\n    overflow-y: auto;\r\n    padding-right: 8px;\r\n\r\n    // Custom scrollbar\r\n    &::-webkit-scrollbar {\r\n      width: 6px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n      background: #f1f5f9;\r\n      border-radius: 10px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n      background: linear-gradient(135deg, #4f46e5, #7c3aed);\r\n      border-radius: 10px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb:hover {\r\n      background: linear-gradient(135deg, #3730a3, #5b21b6);\r\n    }\r\n  }\r\n\r\n  .note-card {\r\n    background: #ffffff;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);\r\n    border: 1px solid rgba(226, 232, 240, 0.6);\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    position: relative;\r\n    overflow: hidden;\r\n\r\n    &::before {\r\n      content: '';\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      width: 4px;\r\n      height: 100%;\r\n      background: linear-gradient(135deg, #4f46e5, #7c3aed);\r\n      opacity: 0;\r\n      transition: opacity 0.3s ease;\r\n    }\r\n\r\n    &:hover {\r\n      transform: translateY(-2px);\r\n      box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);\r\n      border-color: rgba(79, 70, 229, 0.2);\r\n\r\n      &::before {\r\n        opacity: 1;\r\n      }\r\n    }\r\n\r\n    .note-header {\r\n      margin-bottom: 12px;\r\n\r\n      h4 {\r\n        font-size: 1.1rem;\r\n        font-weight: 600;\r\n        color: #1e293b;\r\n        margin: 0;\r\n        line-height: 1.3;\r\n      }\r\n    }\r\n\r\n    .note-body {\r\n      font-size: 14px;\r\n      color: #475569;\r\n      margin-bottom: 16px;\r\n      line-height: 1.5;\r\n\r\n      p {\r\n        margin: 0;\r\n        display: -webkit-box;\r\n        -webkit-line-clamp: 3;\r\n        -webkit-box-orient: vertical;\r\n        overflow: hidden;\r\n      }\r\n    }\r\n\r\n    .note-footer {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      font-size: 12px;\r\n      color: #64748b;\r\n      padding-top: 12px;\r\n      border-top: 1px solid #f1f5f9;\r\n\r\n      span {\r\n        background: rgba(248, 250, 252, 0.8);\r\n        padding: 4px 8px;\r\n        border-radius: 6px;\r\n        font-weight: 500;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 4px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive design\r\n@media (max-width: 768px) {\r\n  .charts-widget-notes {\r\n    padding: 16px;\r\n    border-radius: 12px;\r\n\r\n    h3 {\r\n      font-size: 1.2rem;\r\n      margin-bottom: 16px;\r\n    }\r\n\r\n    .notes-grid {\r\n      gap: 12px;\r\n      max-height: 300px;\r\n    }\r\n\r\n    .note-card {\r\n      padding: 16px;\r\n\r\n      .note-header h4 {\r\n        font-size: 1rem;\r\n      }\r\n\r\n      .note-body {\r\n        font-size: 13px;\r\n        margin-bottom: 12px;\r\n      }\r\n\r\n      .note-footer {\r\n        flex-direction: column;\r\n        gap: 8px;\r\n        align-items: flex-start;\r\n\r\n        span {\r\n          font-size: 11px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
